import { Fade } from "@mui/material"
import info from "../../data/info"
import SocialNetButtons from "../Main/SocialNetButtons"
import timeout from "../../data/timeout"
import { logMessage } from "../../utils/utils"

const Contacts = () => {
  const scrollUp = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
  setTimeout(() => {
    scrollUp()
  }, 100)
  return (
    <Fade timeout={timeout} in>
      <div className="pt- flex flex-col justify-between min-h-screen">
        <div className="h-24"></div>
        <p className="text-3xl  text-[#002998ef]">Контакти:</p>
        <div className="grow-0 sm:grow">
          <div className="max-w-[1110px] mt-4 xs:mt-10 px-4 mx-auto flex flex-col xs:flex-row-reverse items-center xs:items-start justify-around">
            <div className="text-left xs:text-lg md:text-xl">
              <p>{info.city.ua}</p>
              <p>ЖК У-Квартал</p>
              <p>{info.street.ua}</p>
              <div className="text-2xl">
                <a href={info.tel.number}>{info.tel.text}</a>
                <br />
                <a href={info.tel2.number}>{info.tel2.text}</a>
              </div>
              <div className=" mt-4">
                <SocialNetButtons />
              </div>
              <div className="mt-4">
                <div className="text-[#002998ef] font-bold">Графік роботи:</div>
                <div>{`Понеділок - П'ятниця: ${info.schedule.weekdays}`}</div>
                <div>{`Субота, Неділя: ${info.schedule.weekend}`}</div>
              </div>
            </div>

            <div className="mt-8">
              <iframe src={info.mapPoint} width="370" height="370"></iframe>
              {/* <div className="h-32"></div> */}
            </div>
          </div>
        </div>
      </div>
    </Fade>
  )
}

export default Contacts
